import React from 'react';
import { PaddingContainer } from '../../components/common/styled';
import { GridFooter } from '../../components/modules/GridLayout/styled';
import { FOOTER_PRICING_WRAPPER_TESTID } from './constants';
import { StickyFooterTncWrapper, StickyFooterWrapperDesktop } from './styled';
// nonsticky footer for CA desktop
// sticky footer for all other countries and SCO desktop
var GridFooterDesktop = function GridFooterDesktop(_ref) {
  var ctaContent = _ref.ctaContent,
    taxDetailsContent = _ref.taxDetailsContent,
    tncContent = _ref.tncContent,
    isReviewStep = _ref.isReviewStep,
    reviewStepEnabled = _ref.reviewStepEnabled,
    newUserNoMop = _ref.newUserNoMop;
  return /*#__PURE__*/React.createElement(GridFooter, {
    direction: 'column',
    "data-test": FOOTER_PRICING_WRAPPER_TESTID
  }, reviewStepEnabled && !isReviewStep ? /*#__PURE__*/React.createElement(StickyFooterWrapperDesktop, null, taxDetailsContent, /*#__PURE__*/React.createElement(PaddingContainer, {
    top: 5
  }, ctaContent)) : /*#__PURE__*/React.createElement(StickyFooterTncWrapper, null, /*#__PURE__*/React.createElement(StickyFooterWrapperDesktop, null, !reviewStepEnabled && !newUserNoMop && /*#__PURE__*/React.createElement(PaddingContainer, {
    bottom: 5
  }, ctaContent), /*#__PURE__*/React.createElement(PaddingContainer, {
    top: 5,
    bottom: 5
  }, tncContent), /*#__PURE__*/React.createElement(PaddingContainer, {
    top: 5,
    bottom: 5
  },
  // show tax for all countries except for CA review step and SCO
  !isReviewStep && !newUserNoMop && taxDetailsContent), (reviewStepEnabled || newUserNoMop) && /*#__PURE__*/React.createElement(PaddingContainer, {
    top: 5
  }, ctaContent))));
};

// nonsticky footer for CA mweb
// sticky footer for all other countries and SCO mweb
var GridFooterMobile = function GridFooterMobile(_ref2) {
  var ctaContent = _ref2.ctaContent,
    taxDetailsContent = _ref2.taxDetailsContent,
    tncContent = _ref2.tncContent,
    isReviewStep = _ref2.isReviewStep,
    reviewStepEnabled = _ref2.reviewStepEnabled;
  return /*#__PURE__*/React.createElement(GridFooter, {
    direction: 'column',
    "data-test": FOOTER_PRICING_WRAPPER_TESTID
  }, reviewStepEnabled && !isReviewStep ? /*#__PURE__*/React.createElement(React.Fragment, null, taxDetailsContent, /*#__PURE__*/React.createElement(PaddingContainer, {
    top: 5
  }, ctaContent)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StickyFooterTncWrapper, null, !reviewStepEnabled && /*#__PURE__*/React.createElement(PaddingContainer, {
    bottom: 5
  }, ctaContent), /*#__PURE__*/React.createElement(PaddingContainer, {
    top: 5,
    bottom: 5
  }, tncContent), /*#__PURE__*/React.createElement(PaddingContainer, {
    top: 5,
    bottom: 5
  },
  // show tax for all countries except for CA review step
  !isReviewStep && taxDetailsContent), reviewStepEnabled && /*#__PURE__*/React.createElement(PaddingContainer, {
    top: 5
  }, ctaContent))));
};
var CartCheckoutFooter = function CartCheckoutFooter(props) {
  var Footer = props.isMobile ? GridFooterMobile : GridFooterDesktop;
  return /*#__PURE__*/React.createElement(Footer, props);
};
CartCheckoutFooter.displayName = 'CartCheckoutFooter';
export default CartCheckoutFooter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/CartCheckout/CartCheckoutFooter.js
// module id = 4361
// module chunks = 11